import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";

export const SubmitButton = ({ isSubmitting = false }) => {
  return (
    <div className="flex justify-end pt-4">
      <Button
        type="submit"
        disabled={isSubmitting}
        className="bg-igbanwo-mint hover:bg-igbanwo-mint/90 text-white"
      >
        {isSubmitting ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin mr-2" />
            Creating...
          </>
        ) : (
          "Create Listing"
        )}
      </Button>
    </div>
  );
};
